;(function () {
	'use strict';

	if (!customElements.get('trending-products')) {
		class TrendingProducts extends HTMLElement {
			constructor() {
				super();
				this.track    = this.querySelector('.ab-tp-track');
				this.slides   = Array.from(this.querySelectorAll('.ab-tp-slide'));
				this.nextBtns = Array.from(this.querySelectorAll('.ab-next'));
				this.prevBtns = Array.from(this.querySelectorAll('.ab-prev'));
				this.currentIndex = 0;
				this.perView      = 1;
				this.spaceBetween = 30;
			}

			connectedCallback() {
				if (!this.track || this.slides.length === 0) return;

				this.init();
				window.addEventListener('resize', () => this.init());

				// Sync index when user swipes manually on touch
				this.track.addEventListener('scroll', () => this._onScroll(), { passive: true });

				this.nextBtns.forEach(btn => btn.addEventListener('click', () => this.next()));
				this.prevBtns.forEach(btn => btn.addEventListener('click', () => this.prev()));
			}
		}

		TrendingProducts.prototype._getConfig = function () {
			const w = window.innerWidth;
			let { slidesPerView, gap } = this.dataset;
			const spaceBetween = gap === 'true' ? 0 : 30;
			let perView;

			// Match original breakpoints exactly
			if (w >= 1100) {
				perView = parseFloat(slidesPerView) || 3.3;
			} else if (w >= 950) {
				perView = 2.3;
			} else if (w >= 750) {
				perView = 1.4;
			} else {
				perView = 1;
			}

			return { perView, spaceBetween };
		};

		TrendingProducts.prototype.init = function () {
			const { perView, spaceBetween } = this._getConfig();
			this.perView      = perView;
			this.spaceBetween = spaceBetween;

			const trackWidth  = this.track.clientWidth;
			const slideWidth  = (trackWidth - spaceBetween * (perView - 1)) / perView;

			this.slides.forEach((slide, i) => {
				slide.style.width       = slideWidth + 'px';
				slide.style.marginRight = i < this.slides.length - 1 ? spaceBetween + 'px' : '0px';
			});

			// Restore position after resize without animation
			const target = this.slides[this.currentIndex];
			if (target) {
				this.track.scrollTo({ left: target.offsetLeft, behavior: 'instant' });
			}

			this._updateNavState();
		};

		TrendingProducts.prototype.next = function () {
			this._goTo(this.currentIndex + 1);
		};

		TrendingProducts.prototype.prev = function () {
			this._goTo(this.currentIndex - 1);
		};

		TrendingProducts.prototype._goTo = function (index) {
			const maxIndex = Math.max(0, this.slides.length - Math.floor(this.perView));
			index = Math.max(0, Math.min(index, maxIndex));
			this.currentIndex = index;

			const target = this.slides[index];
			if (target) {
				this.track.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
			}

			this._updateNavState();
		};

		TrendingProducts.prototype._onScroll = function () {
			const scrollLeft = this.track.scrollLeft;
			let closest = 0;
			let minDiff  = Infinity;

			this.slides.forEach((slide, i) => {
				const diff = Math.abs(slide.offsetLeft - scrollLeft);
				if (diff < minDiff) { minDiff = diff; closest = i; }
			});

			this.currentIndex = closest;
			this._updateNavState();
		};

		TrendingProducts.prototype._updateNavState = function () {
			const maxIndex = Math.max(0, this.slides.length - Math.floor(this.perView));
			const atStart  = this.currentIndex <= 0;
			const atEnd    = this.currentIndex >= maxIndex;

			this.prevBtns.forEach(btn => btn.classList.toggle('ab-nav--disabled', atStart));
			this.nextBtns.forEach(btn => btn.classList.toggle('ab-nav--disabled', atEnd));
		};

		customElements.define('trending-products', TrendingProducts);
	}
})();
